import BeatLoader from "react-spinners/BeatLoader";

export type LoaderProps = {
    color?: string;
    size?: number;
}

export default function Loader({ color = "#bbb", size = 15 }: LoaderProps) {
    return <BeatLoader color={color} size={size} />;
}